export const DELAY_TIME = 250;

export const TRACK_EVENT_DELAY_TIME = 2000;

export const PAGE_SIZE = 10000;
